import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_WITHDRAWN_USERS } from '../../apollo/queries';
import '../css/CustomerSupportPage.css';

const CustomerSupportPage = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchType, setSearchType] = useState('email');

    // GraphQL 쿼리
    const { data, loading, error, refetch } = useQuery(GET_WITHDRAWN_USERS, {
        variables: { searchTerm, searchType },
        fetchPolicy: 'cache-and-network'
    });

    const handleSearch = () => {
        refetch({ searchTerm, searchType });
    };

    const handleSearchTermChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchTypeChange = (e) => {
        setSearchType(e.target.value);
    };

    // 날짜 포맷팅 함수
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const year = date.getFullYear().toString().substr(-2);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // 연락처 포맷팅 함수
    const formatContact = (phone, mobile) => {
        return mobile || phone || '-';
    };

    // 데이터 처리
    const withdrawnUsers = data?.withdrawnUsers || [];
    const totalCount = withdrawnUsers.length;

    if (loading) {
        return (
            <div className="admin-main-content">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>탈퇴한 회원 정보를 불러오는 중...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="admin-main-content">
                <div className="error-container">
                    <p>탈퇴한 회원 정보를 불러오는 중 오류가 발생했습니다.</p>
                    <button onClick={() => refetch()}>다시 시도</button>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="breadcrumb">
                <span>홈 &gt; 고객지원</span>
            </div>
            <div className="admin-main-content">
                <aside className="admin-sidebar">
                    <div className="sidebar-menu">
                        <h3>고객 지원</h3>
                        <ul>
                            <li className="active">회원 탈퇴 내역</li>
                        </ul>
                    </div>
                </aside>
                <main className="admin-content-support">
                    <div className="page-header">
                        <div className="page-title-bar"></div>
                        <h2>회원 탈퇴 내역</h2>
                    </div>

                    <div className="support-search-filters">
                        <label>검색 명</label>
                        <select 
                            className="filter-select" 
                            value={searchType}
                            onChange={handleSearchTypeChange}
                        >
                            <option value="email">아이디</option>
                            <option value="name">이름</option>
                            <option value="company">회사명</option>
                            <option value="phone">연락처</option>
                        </select>
                        <input 
                            type="text" 
                            className="filter-input" 
                            placeholder="해당 정보를 기입하세요." 
                            value={searchTerm}
                            onChange={handleSearchTermChange}
                        />
                    </div>
                    <button className="search-button-support" onClick={handleSearch}>
                        검 색
                    </button>

                    <div className="support-list-container">
                        <div className="support-list-header">
                            <span>총 회원 수 : {totalCount}명</span>
                        </div>
                        <table className="support-table">
                            <thead>
                                <tr>
                                    <th>아이디</th>
                                    <th>회사명</th>
                                    <th>담당자</th>
                                    <th>연락처</th>
                                    <th>로그인 횟수</th>
                                    <th>견적 수</th>
                                    <th>가입일시</th>
                                </tr>
                            </thead>
                            <tbody>
                                {withdrawnUsers.map(user => (
                                    <tr key={user.id}>
                                        <td data-label="아이디">{user.email}</td>
                                        <td data-label="회사명">{user.company || '-'}</td>
                                        <td data-label="담당자">{user.name}</td>
                                        <td data-label="연락처">{formatContact(user.phone, user.mobile)}</td>
                                        <td data-label="로그인 횟수">{user.loginCount}</td>
                                        <td data-label="견적 수">{user.quotationCount}</td>
                                        <td data-label="가입일시">{formatDate(user.createdAt)}</td>
                                    </tr>
                                ))}
                                {withdrawnUsers.length === 0 && (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                            탈퇴한 회원이 없습니다.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button>&lt;</button>
                            <span>1 / 1</span>
                            <button>&gt;</button>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default CustomerSupportPage; 